let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4V6Hw")).then(() => parcelRequire('hIrNo'));